"use client";

import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import "./index.scss";
import React, { useState } from "react";
import useViewType from "@/utils/Hooks/useViewType";
import Image from "next/image";
import { AnimatedCard } from "./AnimatedCard";
import Counter from "../../components/new/Common/Counter";
import { formatNumber } from "@/utils/strapiTojs";
import GSTexture from "../../../public/images/new/GS-Texture.png";
interface IProps {
  card: ICard;
  isSubIndustry: boolean;
  logos?: any;
}
interface ICard {
  id: number;
  size_in_billion: number;
  avg_salary_in_inr: number;
  jobs_in_market_2024: number;
}
const StatsWithLottie = ({
  card,
  isSubIndustry,
  logos
}: IProps) => {
  const isMobile = useViewType(576);
  const [hovered, setHovered] = useState(false);
  const [hovered1, setHovered1] = useState(false);
  const [hovered3, setHovered3] = useState(false);
  return <div className="stats_section" data-sentry-component="StatsWithLottie" data-sentry-source-file="index.tsx">
      <div className="stats_section-stats_wrapper">
        <div className="stats_section-stats_wrapper-item">
          <Image className="stats_section-stats_wrapper-item-grid" src={GSTexture} alt="grid" loading="lazy" onMouseEnter={() => setHovered1(true)} onMouseLeave={() => setHovered1(false)} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
          <div>
            <div className="para-bold">
              $
              <Counter targetValue={formatNumber(card.size_in_billion).number} data-sentry-element="Counter" data-sentry-source-file="index.tsx" />{" "}
              Million
            </div>
            <p className="para_type">industry size</p>
          </div>

          <div className="stats_section-stats_wrapper-lottie-2">
            {(hovered1 || isMobile) && <DotLottieReact autoplay speed={1.5} src="/public/images/LottieFiles/Bar Graph.lottie" className="lottie-vid-2"></DotLottieReact>}
            {!hovered1 && <Image className="main-image-2" alt="sds" src="/public/images/new/bar_chart.svg" width={100} height={100}></Image>}
          </div>
        </div>

        <div className="stats_section-stats_wrapper-item">
          <Image className="stats_section-stats_wrapper-item-grid" src={GSTexture} alt="grid" loading="lazy" onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
          <div>
            <div className="para-bold">
              <Counter targetValue={formatNumber(card.jobs_in_market_2024).number} data-sentry-element="Counter" data-sentry-source-file="index.tsx" />
              K+
            </div>
            <p className="para_type">jobs in market (2024)</p>
          </div>
          <div className="stats_section-stats_wrapper-lottie">
            {(hovered || isMobile) && <DotLottieReact autoplay speed={1.5} src="/images/LottieFiles/Briefcase.lottie" className="lottie-vid"></DotLottieReact>}
            {!hovered && <Image className="main-image" alt="sds2" src="/images/briefcase.png" width={100} height={100}></Image>}
          </div>
        </div>

        <div className="stats_section-stats_wrapper-item">
          <Image className="stats_section-stats_wrapper-item-grid" src={GSTexture} alt="grid" loading="lazy" onMouseEnter={() => setHovered3(true)} onMouseLeave={() => setHovered3(false)} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
          <div>
            <div className="para-bold">
              ₹{(card?.avg_salary_in_inr || 2000000).toLocaleString()}+
            </div>
            <p className="para_type">Average Salary</p>
          </div>
          <div className="stats_section-stats_wrapper-lottie-3">
            {(hovered3 || isMobile) && <DotLottieReact autoplay speed={1.5} src="/images/LottieFiles/Coin.lottie" className="lottie-vid-3"></DotLottieReact>}
            {!hovered3 && <Image className="main-image-3" alt="sds" src="/images/new/rupee.png" width={100} height={100}></Image>}
          </div>
        </div>

        <div className="stats_section-stats_wrapper-item">
          <p>
            {!isSubIndustry ? "Shape your career as a" : "Top Employers Hiring"}
          </p>
          {isSubIndustry ? <AnimatedCard logos={logos} isSubIndustryPage></AnimatedCard> : <AnimatedCard></AnimatedCard>}
        </div>
      </div>
    </div>;
};
export default StatsWithLottie;